import { string, object, boolean, date } from "yup"

export const patientIssuerFormSchema = object({
  IssuerName: string()
    .max(100, "Maximum Length Should be 100")
    .label("Patient Issuer Name")
    .required("Patient issuer name is required field"),
  reportVersion: string().label("Report Version"),
  isIssuerActive: boolean().label("Patient Issuer Rule Active"),
  isReplaceOriginalReport: boolean().label("Replace Original Report"),
  isExcludeAIReport: boolean().label("Exclude AI Report"),
  isDefaultReportTitle: boolean().label("Default Report Title"),
  isSendHL7Results: boolean().label("Send HL7 Results"),
  isTitleOnTop: boolean().label("Title on Top"),
  isQRCodeIncluded: boolean().label("QR Code Included"),
  isKeyImageDisclaimerEnabled: boolean().label("Key Image Disclaimer Enabled"),
  isV3PhraseReplaced: boolean().label("V3 Phrase Replaced"),
  isRadiologistProfileQRCode: boolean().label("Radiologist Profile QR Code"),
  isEducationalVideosQRCode: boolean().label("Educational QR Code Included"),
  isAutomationEnabled: boolean().label("Automation Enabled"),
  isSpondylolisthesisOn: boolean().label("Spondylolisthesis On"),
  isDermatomesOn: boolean().label("Dermatomes On"),
  isDiskInnervation: boolean().label("Disk Innervation On"),
  qaStopDate: date().label("QA Stop Date").optional().nullable(),
  isGlossaryEnabled: boolean().label("Glossary Enabled"),
  customKeywords: string()
    .label("Custom Keywords")
    .max(255, "Maximum Length Should be 255")
    .optional(),
  globalKeywords: string()
    .label("Global Keywords")
    .max(255, "Maximum Length Should be 255")
    .optional(),
  brain_issuer_setting: object({
    isBrainOn: boolean().label("Brain"),
    isWhiteMatterLesions: boolean().label("Brain White Matter Lesions"),
    isMicroHemorrhages: boolean().label("Brain Micro Hemorrhages"),
    isCoupContrecoup: boolean().label(
      "Brain Lateral Coup Coup/Contrecoup Injury"
    ),
  }),
  spine_issuer_setting: object({
    isSpineOn: boolean().label("Spine"),
    isSagittalHerniation: boolean().label("Sagittal Herniation"),
    isSagittalBulges: boolean().label("Sagittal Bulges"),
    isSagittalSignalLoss: boolean().label("Sagittal Signal Loss"),
    isSagittalOsteophytes: boolean().label("Sagittal Osteophytes"),
    isSagittalFissures: boolean().label("Sagittal Fissures"),
    isSagittalEdemas: boolean().label("Sagittal Edemas"),
    isSagittalDeformations: boolean().label("Sagittal Deformations"),
    isSagittalCompressions: boolean().label("Sagittal Compressions"),
    isSchmorlsNodes: boolean().label("Schmorl's Nodes"),
    isSagittal3dModelingOn: boolean().label("Sagittal 3D Modeling"),
    isAxialHerniation: boolean().label("Axial Herniation"),
    isAxialBulges: boolean().label("Axial Bulges"),
    isAxialArthropathy: boolean().label("Axial Arthropathy"),
    isAxialEffusion: boolean().label("Axial Effusion"),
    isAxialHerniationOnBulges: boolean().label("Axial Herniation on Bulges"),
    isAxialHyperintenseSignal: boolean().label("Axial Hyperintense Signal"),
    isAxialAnnularFissures: boolean().label("Axial Annular Fissures"),
    isAxialFacetEdema: boolean().label("Axial Facet Edema"),
    isAxialCompressions: boolean().label("Axial Compressions"),
    isAxialDeformations: boolean().label("Axial Deformations"),
    isAxialEdemas: boolean().label("Axial Edemas"),
    isAxialSyrinx: boolean().label("Axial Syrinx"),
    isAxial3dModelingOn: boolean().label("Axial 3D Modeling"),
  }),
  knee_issuer_setting: object({
    isKneeOn: boolean().label("Knee"),
    // Deep View
    isDeepViewTears: boolean().label("Deep View Tears"),
    isMeniscalTearAxialView: boolean().label("Meniscal Tear Axial View"),
    isDeepViewOsteophytes: boolean().label("Deep View Osteophytes"),
    isChondromalacia: boolean().label("Chondromalacia"),
    isDeepViewBoneMarrowEdema: boolean().label("Deep View Bone Marrow Edema"),
    // Superficial View
    isSpatellaDisplacement: boolean().label("Spatella Displacement"),
    isSuperficialViewFractures: boolean().label("Superficial View Fractures"),
    isSuperficialViewTears: boolean().label("Superficial View Tears"),
    isSuperficialViewTendonitis: boolean().label("Superficial View Tendonitis"),
    isAnserineBursitis: boolean().label("Anserine Bursitis"),
    // Lateral View
    isPvns: boolean().label("PVNS"),
    isLateralEffusion: boolean().label("Lateral Effusion"),
    isRecessCyst: boolean().label("Recess Cyst"),
    // Frontal View
    isOcdLesion: boolean().label("OCD Lesion"),
    isLooseBody: boolean().label("Loose Body"),
    isKissingLesion: boolean().label("Kissing Lesion"),
    isExtrudedMeniscus: boolean().label("Extruded Meniscus"),
    isJointSpaceNarrowing: boolean().label("Joint Space Narrowing"),
    isFrontalViewMeniscalTear: boolean().label("Frontal View Meniscal Tear"),
    // Sagittal View
    isSagittalViewOsteophytes: boolean().label("Sagittal View Osteophytes"),
    isSagittalViewTears: boolean().label("Sagittal View Tears"),
    isSagittalViewEffusions: boolean().label("Sagittal View Effusions"),
    isSagittalViewTendonitis: boolean().label("Sagittal View Tendonitis"),
    isSagittalViewEdemas: boolean().label("Sagittal View Edemas"),
    isSagittalViewPrepatellarBursitis: boolean().label(
      "Sagittal View Prepatellar Bursitis"
    ),
  }),
  shoulder_issuer_setting: object({
    isShoulderOn: boolean().label("Shoulder"),
    isDeepEffusion: boolean().label("Deep Effusion"),
    isDeepBankartLesion: boolean().label("Deep Bankart Lesion"),
    isDeepReverseHillSachsLesion: boolean().label(
      "Deep Reverse Hill-Sachs Lesion"
    ),
    isDeepBicepTenosynovitis: boolean().label("Deep Bicep Tenosynovitis"),
    isDeepAcJointHypertrophy: boolean().label("Deep AC Joint Hypertrophy"),
    isDeepBicepTendonopathy: boolean().label("Deep Bicep Tendonopathy"),
    isDeepBicepTears: boolean().label("Deep Bicep Tears"),
    // Lateral View
    isLateralLabralTears: boolean().label("Lateral Labral Tears"),
    isLateralSupraspinatusAtrophy: boolean().label(
      "Lateral Supraspinatus Atrophy"
    ),
    isLateralRcTears: boolean().label("Lateral RC Tears"),
    isLateralTendonosis: boolean().label("Lateral Tendonosis"),
    isLateralAdhesiveCapsulitis: boolean().label("Lateral Adhesive Capsulitis"),
    isLateralBoneMarrowEdema: boolean().label("Lateral Bone Marrow Edema"),
    isLateralOsteophytes: boolean().label("Lateral Osteophytes"),
    isLateralGlenoidCartilageLoss: boolean().label(
      "Lateral Glenoid Cartilage Loss"
    ),
    isLateralLigamentTears: boolean().label("Lateral Ligament Tears"),
    isLateralBicepTenosynovitis: boolean().label("Lateral Bicep Tenosynovitis"),
    isLateralInfraspinatusTear: boolean().label("Lateral Infraspinatus Tear"),
    isLateralInfraspinatusTendonosis: boolean().label(
      "Lateral Infraspinatus Tendonosis"
    ),
    isLateralTeresMinorTear: boolean().label("Lateral Teres Minor Tear"),
    isLateralTeresMinorTendonosis: boolean().label(
      "Lateral Teres Minor Tendonosis"
    ),
    // Frontal View
    isFrontalSupraspinatusAtrophy: boolean().label(
      "Frontal Supraspinatus Atrophy"
    ),
    isFrontalLabralTears: boolean().label("Frontal Labral Tears"),
    isFrontalRcTears: boolean().label("Frontal RC Tears"),
    isFrontalTendonosis: boolean().label("Frontal Tendonosis"),
    isFrontalAcJointHypertrophy: boolean().label(
      "Frontal AC Joint Hypertrophy"
    ),
    isFrontalIntraArticularLooseBodies: boolean().label(
      "Frontal Intra-Articular Loose Bodies"
    ),
    isFrontalBoneMarrowEdema: boolean().label("Frontal Bone Marrow Edema"),
    isFrontalSoftTissueEdema: boolean().label("Frontal Soft Tissue Edema"),
    isFrontalBursitis: boolean().label("Frontal Bursitis"),
    isFrontalAcJointOAWithPericapsularEdema: boolean().label(
      "Frontal AC Joint OA with Pericapsular Edema"
    ),
    isFrontalInfraspinatusTear: boolean().label("Frontal Infraspinatus Tear"),
    isFrontalInfraspinatusTendonosis: boolean().label(
      "Frontal Infraspinatus Tendonosis"
    ),
    isFrontalTeresMinorTear: boolean().label("Frontal Teres Minor Tear"),
    isFrontalTeresMinorTendonosis: boolean().label(
      "Frontal Teres Minor Tendonosis"
    ),
    isFrontalPartialArticularTears: boolean().label(
      "Frontal Partial Articular Tears"
    ),
    // Superficial View
    isSuperficialSupraspinatusAtrophy: boolean().label(
      "Superficial Supraspinatus Atrophy"
    ),
    isSuperficialTendonosisSupraspinatus: boolean().label(
      "Superficial Tendonosis Supraspinatus"
    ),
    isSuperficialTendonosisSubscapularis: boolean().label(
      "Superficial Tendonosis Subscapularis"
    ),
    isSuperficialRcTearSupraspinatus: boolean().label(
      "Superficial RC Tear Supraspinatus"
    ),
    isSuperficialRcTearSubscapularis: boolean().label(
      "Superficial RC Tear Subscapularis"
    ),
    isSuperficialAcJointHypertrophy: boolean().label(
      "Superficial AC Joint Hypertrophy"
    ),
    // Posterior View
    isPosteriorInfraspinatusAtrophy: boolean().label(
      "Posterior Infraspinatus Atrophy"
    ),
    isPosteriorRcTearInfraspinatus: boolean().label(
      "Posterior RC Tear Infraspinatus"
    ),
    isPosteriorCalcificTendonitisInfraspinatus: boolean().label(
      "Posterior Calcific Tendonitis Infraspinatus"
    ),
    isPosteriorTendonosisInfraspinatus: boolean().label(
      "Posterior Tendonosis Infraspinatus"
    ),
    isPosteriorRcTearSupraspinatus: boolean().label(
      "Posterior RC Tear Supraspinatus"
    ),
    isPosteriorCalcificTendonitisSupraspinatus: boolean().label(
      "Posterior Calcific Tendonitis Supraspinatus"
    ),
    isPosteriorTendonosisSupraspinatus: boolean().label(
      "Posterior Tendonosis Supraspinatus"
    ),
    isPosteriorAcHypertrophy: boolean().label("Posterior AC Hypertrophy"),
  }),
})
